import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Inventory } from 'src/app/shared/interfaces/ProductDetailResponse';
import { ApiServices } from 'src/app/shared/services/api.service';
import { DataService } from 'src/app/shared/services/data.service';

interface Warehouse {
  id: number;
  code: string;
}

interface AddOn {
  id: number;
  add_on_category_id: number;
  addon_inventory: Inventory[];
  inventory: Inventory;
  inStock: boolean;
}

interface Category {
  id: number;
  slug: string;
  addOns: Array<AddOn>;
}

@Component({
  selector: 'app-add-ons',
  templateUrl: './add-ons.component.html',
  styleUrls: ['./add-ons.component.scss']
})
export class AddOnsComponent implements OnInit, OnDestroy, OnChanges {
  private subs = new Subscription();
  categories: Category[] = [];
  @Input() addOns: AddOn[] = [];
  @Input() cartItems: any[] = [];
  @Input() modal: any = null;
  @Input() is_hide_cost:any = null;

  currentFragment: string | null = null;
  @Input() selectedWarehouseId: number = null;
  warehousesMap: { [slug: string]: Warehouse[] } = {};

  addOnQty = {};
  isCartProcessing = false;

  constructor(
    private dataService: DataService,
    private toastr: ToastrService,
    private apiService: ApiServices,
  ) {}

  addEditQty(addOn: AddOn, qty: number, eta_qty = 0, quiteMode:boolean = false): void {
    const index = `${addOn.id}_${addOn.inventory?.warehouse_id}`;

    const allQtySum = eta_qty + addOn.inventory?.quantity;
    
      if (qty > allQtySum) {
        if (!quiteMode) {
          this.toastr.error(`Invalid quantity. ${addOn.inventory?.ware_house?.code} has only ${allQtySum} quantity left.`, 'Error');
        }
      } else if (qty < 0) {
        if (!quiteMode) {
          this.toastr.error(`(${addOn.inventory?.ware_house?.code}) Invalid quantity.`, 'Error');
        }
      } else {
        this.addOnQty[index] = qty;
      }
  }

  updateQuantity(addOn, operator:string){
    const index = `${addOn.id}_${addOn.inventory?.warehouse_id}`;

      const qty = parseInt(this.addOnQty[index]);
      const allQtySum = addOn.inventory?.quantity;

    if (operator == "+") {
      if (qty < allQtySum) {
        this.addOnQty[index] += 1;
      }
    } else if (operator == "-") {
      if (qty > 0) {
        this.addOnQty[index] -= 1;
      }
    }
  }

  ngOnInit(): void {
    this.dataService.getAddOnCategories().then((categories: Category[]) => {
      this.categories = categories;
      this.updateCategories();
     setTimeout(()=>{
      if (!this.currentFragment) {
        this.currentFragment = categories[0]?.slug;
        this.selectedWarehouseId = this.warehousesMap[this.currentFragment]?.sort((a, b) => a.id - b.id)[0]?.id
        this.getInventory();
      }
     }, 2500)
    });
  }

  ngOnChanges(): void {
    this.updateCategories();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onWarehouseSelect(event: any): void {
    this.selectedWarehouseId = +event.target.value;
    this.getInventory();
  }


  getInventory() {
    const addOns = this.categories.find(c => c.slug === this.currentFragment)?.addOns || [];
    addOns.forEach(addOn => {
      addOn.inventory = addOn.addon_inventory.find(inv => inv.warehouse_id === this.selectedWarehouseId);
      this.addEditQty(addOn, 1, 0 , true);
      addOn.inStock = addOn.inventory ? addOn.inventory.quantity > 0 : false;
    });
  }

  onTabChange(cat) {
    this.currentFragment = cat.slug

    this.getInventory();
  }

  private updateCategories(): void {
    this.categories = this.categories.map(category => {
      const addOns = this.addOns.filter(addOn => addOn.add_on_category_id === category.id);
      const warehouseIds: number[] = [];
      const warehouses: Warehouse[] = [];
      addOns.forEach(addOn => {
        addOn.addon_inventory.forEach(inv => {
          if (!warehouseIds.includes(inv.ware_house.id)) {
            warehouseIds.push(inv.ware_house.id);
            warehouses.push(inv.ware_house);
          }
        });
      });

      if (!this.currentFragment && warehouseIds.includes(this.selectedWarehouseId!)) {
        this.currentFragment = category.slug;
      }

      this.warehousesMap[category.slug] = warehouses;

      return {
        ...category,
        warehouses,
        addOns
      };
    });

    this.getInventory();
  }

  onAddToCart(addOn: AddOn) {
    const index = `${addOn.id}_${addOn.inventory.warehouse_id}`;

    if(this.addOnQty[index]) {
      const qty = this.addOnQty[index];
      const allQtySum = addOn.inventory.quantity;

      if (qty > allQtySum) {
        this.toastr.error(`Invalid quantity. ${addOn.inventory?.ware_house?.code} has only ${allQtySum} quantity left.`, 'Error');
      } else if (qty < 0) {
        this.toastr.error(`(${addOn.inventory?.ware_house?.code}) Invalid quantity.`, 'Error');
      } else {
        this.addToCart(addOn, qty, index);
      }
    }
  }

  private addToCart(addOn: AddOn, qty: number, index: string): void {
    const session_id = localStorage.getItem('session_id');

    const warehouse_qunatity = {
        warehouse_id: addOn.inventory.warehouse_id,
        quantity: qty,
    };

    const item: any = {
        add_on_id: addOn.id,
        warehouse_qunatity: [warehouse_qunatity],
        quantity: qty
    };

    const data = {
      session_id,
      type: "addon_added_to_cart_directly",
      items: [item],
    };
    this.isCartProcessing = true;
    this.subs.add(
      this.apiService.addToCart(data).subscribe(
        response => {
          this.isCartProcessing = false;
          if (response.status) {
            this.apiService.getCart().subscribe(response => {
              if (response.status) {
                this.dataService.setCartData(response);
              }
            });
            delete this.addOnQty[index];
            this.toastr.success(response.message, 'Success');
          }
        }, error => {
          this.isCartProcessing = false;
          this.toastr.error(error.error.message, 'Error');
        }
      )
    );
  }
}
